'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var defaultLogger = makeLogger();
exports.default = defaultLogger;


function makeLogger(label) {
    var LOG_INFO = false;
    var LOG_ERROR = true;

    function logger() {
        logger.info.apply(logger, arguments);
    }

    logger.info = function logInfo() {
        if (LOG_INFO) {
            var _window$console;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (label) {
                args[0] = '[' + label + '] ' + args[0];
            }
            (_window$console = window.console).log.apply(_window$console, args);
        }
    };

    logger.error = function logError() {
        if (LOG_ERROR) {
            var _window$console2;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            if (label) {
                args[0] = '[' + label + '] ' + args[0];
            }

            (_window$console2 = window.console).error.apply(_window$console2, args);
        }
    };

    logger.assert = function assert(condition) {
        if (condition) {
            return;
        }

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
        }

        this.error.apply(this, ['Assertion failed.'].concat(args));
    };

    logger.setLevel = function setLevel(newLevel) {
        if (newLevel === 0) {
            LOG_ERROR = false;
            LOG_INFO = false;
        } else if (newLevel === 1) {
            LOG_ERROR = true;
            LOG_INFO = false;
        } else if (newLevel === 2) {
            LOG_ERROR = true;
            LOG_INFO = true;
        }
    };

    logger.namespace = function namespace(newLabel) {
        var l = newLabel;
        if (label) {
            l = '[' + label + '][' + l + ']';
        }

        return makeLogger(l);
    };

    return logger;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Logger"]
window._kiwi_exports.libs.Logger = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/Logger.js
// module id = XNCV
// module chunks = 1